module.exports = __webpack_public_path__ + "static/media/timer-save.7530c41c.png";